import { LoanContextProvider } from '../LoanSimulationContext/';

import { CustomerContextProvider } from '../CustomerContext/';

import { CreditProposalResultContextProvider } from '../CreditProposalResultContext';

import { ProductContextProvider } from '../ProductContext';

import { CustomerClassificationContextProvider } from '../CustomerClassificationContext';

import { combineComponents } from '../../utils/combineComponents';

import { PaymentCardsContextProvider } from '../PaymentCardContext';

import { WebsocketContextProvider } from '../WebsocketContext';
import { MerchantContextProvider } from '../MerchantContext';
import { FingerprintContextProvider } from '../FingerprintContext';

const providers = [
  LoanContextProvider,

  CustomerContextProvider,

  CustomerClassificationContextProvider,

  CreditProposalResultContextProvider,

  ProductContextProvider,

  PaymentCardsContextProvider,

  WebsocketContextProvider,

  MerchantContextProvider,

  FingerprintContextProvider
];

export const MainContextProvider = combineComponents(...providers);
